// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
import { fas } from '@fortawesome/free-solid-svg-icons';

import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(
  fas ,
  fab
  // more icons go here
);